import * as Sentry from '@sentry/browser';
import { browserHistory } from 'react-router';
import {
  all,
  call,
  cancel,
  cancelled,
  fork,
  put,
  take,
  takeLatest,
} from 'redux-saga/effects';

import { redirect as redirectGivenPermissions } from '../../lib/check-auth';
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from '../../utilities/localStorage';
import { GENERIC_ERROR_MESSAGE } from '../../utilities/SagasHelper';
import * as api from '../../utilities/ServiceManager';
import { requestPassword as requestPasswordService } from '../../utilities/ServiceManager';
import {
  getSessionStorageItem,
  removeSessionStorageItem,
} from '../../utilities/sessionStorage';
import { setMessage } from '../Admins/actions';
import { REQUEST_PASSWORD } from '../Admins/actionTypes';
import { setFilters } from '../Books/actions';
import { VERIFY_IS_MAINTENANCE } from '../User/constants';
import {
  AUTHY_ERROR,
  AUTHY_REQUESTING,
  AUTHY_VERIFICATION_REQUEST,
  LOGIN_DEFAULT,
  LOGIN_ERROR,
  LOGIN_REQUESTING,
  LOGIN_SUCCESS,
  LOGOUT_USER_SAGAS,
  RESEND_CODE_DONE,
  RESEND_CODE_REQUEST,
  RESET_STATUS,
  USER_SET,
  USER_UNSET,
} from './constants';

function logout() {
  Sentry.setUser({});
  localStorage.clear();
  sessionStorage.clear();
}

export function redirect(permissions) {
  /* Previous location */
  const previousUrl = getSessionStorageItem('url_before_redirected_to_login');
  if (previousUrl) {
    if (previousUrl.includes('maintenance') || previousUrl.includes('login')) {
      browserHistory.replace('/home/mission-control/assignments');
    } else {
      browserHistory.replace(previousUrl);
    }
    removeSessionStorageItem('url_before_redirected_to_login');
    return;
  }
  redirectGivenPermissions(permissions);
}

function* loginFlow(email, password) {
  let response;
  try {
    const userCookie = getLocalStorageItem(String(email));
    // response = yield call(api.login, email, password, userCookie);
    response = yield call(api.login, email, password);
    yield put({ type: USER_SET });
    Sentry.setUser({
      email: response.user.email,
      id: response.user.id,
    });

    // if (response.hasToUse2FA) {
    //   if (userCookie?.key) {
    //     yield put({ type: USER_SET });
    //     yield put({ type: LOGIN_SUCCESS, payload: response });
    //     yield put(setFilters(response.user.filters));
    //     redirect(
    //       response.permissions,
    //     );
    //   } else {
    //     yield put({ type: AUTHY_REQUESTING, payload: response });
    //   }
    // } else {
    yield put({ type: USER_SET });
    yield put({ type: LOGIN_SUCCESS, payload: response });
    yield put(setFilters(response.user.filters));
    redirect(response.permissions);
    // }
  } catch (error) {
    yield put({ type: LOGIN_ERROR, error });
  } finally {
    if (yield cancelled()) {
      browserHistory.replace('/');
    }
  }

  return response;
}

function* loginWatcher() {
  while (true) {
    const { email, password } = yield take(LOGIN_REQUESTING);
    const task = yield fork(loginFlow, email, password);
    const action = yield take([USER_UNSET, LOGIN_ERROR]);
    if (action.type === USER_UNSET) yield cancel(task);
    yield call(logout);
  }
}

function* resendCodeRequestWatcher() {
  yield takeLatest(RESEND_CODE_REQUEST, resendCodeRequest);
}

function* resendCodeRequest(type) {
  const email = type.email;
  try {
    yield call(api.resendCode, email);
    yield put({ type: RESEND_CODE_DONE, payload: { email } });
  } catch (error) {
    yield put({ type: AUTHY_ERROR, error });
  }
}

function* resetStatusWatcher() {
  yield takeLatest(RESET_STATUS, resetStatus);
}

export function* watchUserRequestPassword() {
  yield takeLatest(REQUEST_PASSWORD, requestPassword);
}

function* resetStatus() {
  yield put({ type: LOGIN_DEFAULT });
  location.reload();
}

function* authyVerificationRequestWatcher() {
  yield takeLatest(AUTHY_VERIFICATION_REQUEST, authyVerificationRequest);
}

function* authyVerificationRequest(type) {
  const code = type.code;
  const email = type.email;
  let response;
  try {
    response = yield call(api.verificateAuthyCode, {
      code,
      email,
    });

    yield put({ type: LOGIN_SUCCESS, payload: response });
    yield put(setFilters(response.user.filters));
    const expirationTime = 31536000000;
    setLocalStorageItem(String(email), { key: email }, expirationTime);
    redirect(response.permissions);
  } catch (error) {
    yield put({ type: AUTHY_ERROR, error });
  }
}

export function* requestPassword(action) {
  try {
    yield put(setMessage(''));
    const response = yield call(requestPasswordService, action.email);
    if (response) {
      yield put(setMessage('true'));
    } else {
      yield put(
        setMessage('This email does not exist in database, please check it'),
      );
    }
  } catch (exception) {
    yield put(
      setMessage(
        exception.response ? exception.response.data : GENERIC_ERROR_MESSAGE,
      ),
    );
  }
}

/**
 * Update study programs of reference
 */
function* logoutSagasWatcher() {
  yield takeLatest(LOGOUT_USER_SAGAS, logoutSagas);
}

function* logoutSagas() {
  try {
    yield call(api.logout);
  } catch (exception) {}
}

function* verifyIsMaintenanceSagaWatcher() {
  yield takeLatest(VERIFY_IS_MAINTENANCE, verifyIsMaintenanceSaga);
}

export function* verifyIsMaintenanceSaga() {
  try {
    const response = yield call(api.getLoggedAdmin);
    if (!response.isMaintenance) {
      browserHistory.replace('/home/mission-control/assignments');
    }
  } catch (error) {}
}

export default function* sagas() {
  yield all([
    loginWatcher(),
    logoutSagasWatcher(),
    verifyIsMaintenanceSagaWatcher(),
    authyVerificationRequestWatcher(),
    resendCodeRequestWatcher(),
    resetStatusWatcher(),
    watchUserRequestPassword(),
  ]);
}
